import { render } from "./usable_subscription.vue?vue&type=template&id=5822c042"
import script from "./usable_subscription.vue?vue&type=script&lang=js"
export * from "./usable_subscription.vue?vue&type=script&lang=js"

import exportComponent from "/vuebuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__